import React from 'react';
import Header from './Header.jsx'
import LegalDocument from './LegalDocument.jsx'
import { PRIVACY } from './legalContent'
import './Content.scss'

class Privacy extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="content">
          <LegalDocument doc={PRIVACY} />
        </div>
      </>
    )
  }
}

export default Privacy;
